export enum hSatzModel {
  SINGULAR = 'H-Satz',
  PLURAL = 'H-Sätze',
  ICON = 'mdi-alpha-h-box',
  ITEM_KEY = 'hsatz',
  ITEM_KEY_UPDATE = 'hsaetze'
}
